import { render, staticRenderFns } from "./ArticleListingNominativ.vue?vue&type=template&id=e84d2a32&scoped=true"
import script from "./ArticleListingNominativ.vue?vue&type=script&lang=js"
export * from "./ArticleListingNominativ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84d2a32",
  null
  
)

export default component.exports